import { HubInterestToIntent } from '../signup-data/hubInterestMappings'; // Added by GO-Free team
// Long term we would like all intents to be enrolled in the user guide
// At the moment, we are only enrolling the intents that are mapped to a hub interest
// We are trying to avoid the ones defaulted to Sales because they might be from a different flow (eg cms-free)

const intentsToUserGuideEnrollment = Object.values(HubInterestToIntent).flat();
export const getShouldNotEnrollIntent = intent => !intentsToUserGuideEnrollment.includes(intent);